import RequestAbstract from "../abstract";

export default class PublicAppealHasDocuments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-appeal-has-documents";
    }

}
